import searchLineStyle from 'src/components/View/Header/searchLine.style';

const buttonInnerStyle = (theme) => ({
  root: {
    ...searchLineStyle(theme)?.innerField || {},
    backgroundColor: 'none',
    border: 0,
    padding: 0,

    [theme.breakpoints.up('lg')]: {
      '&.small-lg-up': {
        width: '165px',
      },

      '&.large-lg-up': {
        width: '230px',
      },
    },

    '& button, & a': {
      width: '100%',
      height: 'inherit',
    },
  },
});

export default buttonInnerStyle;
